export default "__VITE_ASSET__CVV9GOY___"